var _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalTowerOnDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 80",
    width: 400,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,4) scale(0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 39 A11 11 0 0 1 62 39",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 39 A19 19 0 0 1 70 39",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 40,
    r: 4.5,
    fill: "#38bdf8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 44,
    x2: 51,
    y2: 90,
    stroke: "#38bdf8",
    strokeWidth: 2.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 44 L29 90 M51 44 L73 90",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 90 L24 90 M73 90 L78 90",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 62,
    x2: 60,
    y2: 62,
    stroke: "#38bdf8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 78,
    x2: 65,
    y2: 78,
    stroke: "#38bdf8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 50 L57 62 M57 50 L45 62 M40 66 L62 78 M62 66 L40 78",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 2.4,
    opacity: 0.75
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 40,
    fontFamily: "Inter, sans-serif",
    fontWeight: 800,
    fontSize: 30,
    letterSpacing: -0.6,
    fill: "#e2e8f0"
  }, "Ham Recruiter")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 60,
    fontFamily: "'JetBrains Mono', monospace",
    fontWeight: 500,
    fontSize: 10,
    letterSpacing: 3.2,
    fill: "#64748b"
  }, "FCC ULS \xB7 UPDATED WEEKLY")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalTowerOnDark);
export default __webpack_public_path__ + "static/media/horizontal-tower-on-dark.570a67c2dc189eb74129d99efcb49fc4.svg";
export { ForwardRef as ReactComponent };